import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export function createRouter () {
  return new Router({
    mode: 'history',
    routes: [
      // 首页路由
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue')
      },
      // 商城路由
      {
        path: '/shop/',
        name: 'Shop',
        component: () => import('@/views/Shop.vue')
      },
      {
        path: '/shop/p-:page.html',
        name: 'ShopPage',
        component: () => import('@/views/Shop.vue')
      },
      // 商品详情路由
      {
        path: '/shop/:id.html',
        name: 'ShopDetail',
        component: () => import('@/views/ShopDetail.vue')
      },
      // 写真详情页面路由
      {
        path: '/meinvtupian/:contentId(\\w*).html',
        name: 'PhotoDetail',
        component: () => import('@/views/PhotoDetail.vue')
      },
      // 标签写真页面路由
      {
        path: '/meinvtupian/:parent(\\w*)?/:pinyin(\\w*)?/:page?',
        name: 'Photo',
        component: () => import('@/views/Photo.vue')
      },
      // 模特详细页面路由
      {
        path: '/meinv/:name(\\D*).html',
        name: 'ModelDetail',
        component: () => import('@/views/ModelDetail.vue')
      },
      // 模特页面路由
      {
        path: '/meinv/:parent(\\w*)?/:pinyin(\\w*)?/:page?',
        name: 'Model',
        component: () => import('@/views/Model.vue')
      },
      // 主题拍摄详情页面路由
      {
        path: '/mote/:name(\\w+)',
        name: 'MoteDetail',
        component: () => import('@/views/MoteDetail.vue')
      },
      // 主题拍摄页面路由
      {
        path: '/mote/:page?',
        name: 'Mote',
        component: () => import('@/views/Mote.vue')
      },
      // 主题拍摄详情资讯详情页面路由
      {
        path: '/mote/news/:id.html',
        name: 'MoteNewsDetail',
        component: () => import('@/views/Article.vue')
      },
      // 主题拍摄详情动态页面路由
      {
        path: '/mote/:name/dongtai',
        name: 'MoteMoment',
        component: () => import('@/views/Moment.vue')
      },
      // 主题拍摄详情资讯页面路由
      {
        path: '/mote/:name/zixun',
        name: 'MoteNews',
        component: () => import('@/views/News.vue')
      },
      // 尤果网拍摄服务器页面
      {
        path: '/help/about.html',
        name: 'About',
        component: () => import('@/views/About.vue')
      },
      // 测试路由health
      {
        path: '/health',
        name: 'Health',
        component: () => import('@/views/Health.vue')
      },
    ]
  });
}



// WEBPACK FOOTER //
// ./src/router/index.js